<template>
  <FormField>
    <template #helpTip>
      <div class="help-tip-body">
        <p>The Medicare Number is located on the front of the Medicare card, as seen below:</p>
        <div class="text-center">
          <img src="@/assets/medicare-card-example.jpg"
            class="shadow"
            alt="Medicare Health Insurance Card"
          />
        </div>
      </div>
    </template>

    <template #default="{ attrs, classes }">
      <TextBox
        v-bind="attrs"
        :class="classes"
      />
    </template>
  </FormField>
</template>

<script>
import TextBox from '@/components/formControls/TextBox';
import FormField from './FormField';

export default {
  components: { FormField, TextBox }
};
</script>

<style scoped>
.help-tip-body {
  width: 400px;
}
</style>
